import StatCardForPerformance from '../../../../Components/StatCardForPerformance/StatCardForPerformance';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { changeTab } from '../../../../Features/reportAnalysisSlice';

function PurchaseRatio() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleButtonClick = () => {
        dispatch(changeTab('sales'));
        navigate('/report-and-analytics');
    }

    return (
        <div className='border rounded-lg border-[#EAEAEA] col-span-1 min-h-[50vh] p-5 flex flex-col gap-4'>
            <div className="flex items-center justify-between">
                <h1 className="font-semibold text-base">Purchase Ratio</h1>

                <button onClick={handleButtonClick} className="p-0 outline-none border-none text-[#1055EB] font-semibold text-[12px] leading-6" href="/">View all data</button>
            </div>

            <div className="flex flex-col h-full justify-between gap-3">
                <StatCardForPerformance 
                    statName="Store views"
                    statValue={0}
                    hasPrice={false}
                />
                <StatCardForPerformance 
                    statName="Purchases"
                    statValue={0}
                    hasPrice={false}
                />
                <StatCardForPerformance 
                    statName="Purchase Ratio"
                    statValue={0}
                    hasPrice={false} 
                    // statTrend={12}
                />
            </div>
        </div>
    )
}

export default PurchaseRatio;
